import { VuexModule, Module, Mutation } from "vuex-class-modules";

@Module({ generateMutationSetters: true })
export default class AlarmModule extends VuexModule {
    public showTopBar = true;
    public showFooter = true;

    public alarm = "";
    public error = "";
    public success = "";
    public title: string | null | undefined = "";

    private isHomePanelOpen = false;
    private homePanelOpenIndex = -1;

    private isMyBoatPanelOpen = false;
    private myBoatPanelOpenIndex = -1;

    private isControlPanelOpen = false;
    private controlPanelOpenIndex = -1;

    private isSensorsPanelOpen = false;
    private sensorsPanelOpenIndex = -1;

    @Mutation
    public setHomePanelOpen(value: boolean) {
        console.log("setHomePanelOpen: " + value);
        this.isHomePanelOpen = value;
    }
    @Mutation
    public setHomePanelIndex(value: number) {
        console.log("setHomePanelIndex: " + value);
        this.homePanelOpenIndex = value;
    }
    @Mutation
    public setMyBoatPanelOpen(value: boolean) {
        console.log("setMyBoatPanelOpen: " + value);
        this.isMyBoatPanelOpen = value;
    }
    @Mutation
    public setMyBoatPanelIndex(value: number) {
        console.log("setMyBoatPanelIndex: " + value);
        this.myBoatPanelOpenIndex = value;
    }
    @Mutation
    public setControlPanelOpen(value: boolean) {
        console.log("setControlPanelOpen: " + value);
        this.isControlPanelOpen = value;
    }
    @Mutation
    public setControlPanelIndex(value: number) {
        console.log("setControlPanelIndex: " + value);
        this.controlPanelOpenIndex = value;
    }
    @Mutation
    public setSensorsPanelOpen(value: boolean) {
        console.log("setSensorsPanelOpen: " + value);
        this.isSensorsPanelOpen = value;
    }
    @Mutation
    public setSensorsPanelIndex(value: number) {
        console.log("setSensorsPanelIndex: " + value);
        this.sensorsPanelOpenIndex = value;
    }

    public get getHomePanelOpen() {
        return this.isHomePanelOpen;
    }
    public get getHomePanelIndex() {
        return this.homePanelOpenIndex;
    }
    public get getMyBoatPanelOpen() {
        return this.isMyBoatPanelOpen;
    }
    public get getMyBoatPanelIndex() {
        return this.myBoatPanelOpenIndex;
    }
    public get getControlPanelOpen() {
        return this.isControlPanelOpen;
    }
    public get getControlPanelIndex() {
        return this.controlPanelOpenIndex;
    }
    public get getSensorsPanelOpen() {
        return this.isSensorsPanelOpen;
    }
    public get getSensorsPanelIndex() {
        return this.sensorsPanelOpenIndex;
    }

}
